import React from "react";
import { Box, Checkbox, Chip, IconButton, Tooltip, Typography } from "@mui/material";
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import { FULL_PERMISSION } from "../../../constants/Constant";
import Helper from "../../../utility/helper";
import AllotmentRowItem from "./allotmentRowItem";
import AppConstants from "../../../constants/appConstants";
import AllotmentCredentialRowItem from "./allotmentCredentialRowItem";

const AllotmentRow = (props) => {
    const { classes, item, index } = props;
    const actData = item.actualData;
    const eventInfo = Helper.getStorage('eventInfo');

    return (
        <>
            <Box className={classes.headRowContent}>
                <Box sx={{
                    display: 'flex',
                    width: '5%',
                    flexBasis: '5%',
                    alignItems: 'center',
                    justifyContent: 'center',
                    flexGrow: 1,
                }}>
                    <Checkbox
                        inputProps={{
                            'aria-label': 'Allotment',
                        }}
                        checked={item.selected ? item.selected : false}
                        onChange={(event) => props.onCheckSelect(event, index)}
                        // color="secondary"
                        value={actData.eventUsersID}
                    />
                </Box>
                <Box
                    sx={{
                        display: 'flex',
                        justifyContent: 'left',
                        alignItems: 'start',
                        width: '15%',
                        flexBasis: '15%',
                        flexGrow: 1,
                    }}>
                    <Box sx={{ display: 'flex', justifyContent: 'left', alignItems: 'center', flexDirection: 'row' }}>
                        <Typography
                            variant="h4"
                            flexGrow={1}
                            fontSize={14}
                            fontWeight={400}>
                            <span>{actData.name}</span>
                            <Typography
                                fontSize={11}
                                sx={{
                                    wordBreak: 'break-word',
                                }}>
                                <a
                                    href={`mailto:${actData.email}`}>
                                    {' '}
                                    {actData.email}{' '}
                                </a>
                            </Typography>
                        </Typography>
                    </Box>
                </Box>
                <Box
                    sx={{
                        display: 'flex',
                        justifyContent: 'left',
                        alignItems: 'start',
                        width: '10%',
                        flexBasis: '10%',
                        flexGrow: 1,
                    }}>
                    <Typography
                        variant="h4"
                        flexGrow={1}
                        fontSize={14}
                        fontWeight={400}>
                        <span>{actData.roleName}</span>
                    </Typography>
                </Box>
                <Box
                    sx={{
                        display: 'flex',
                        justifyContent: 'left',
                        flexDirection: 'row',
                        alignItems: 'start',
                        width: '10%',
                        flexBasis: '10%',
                        flexGrow: 1,
                        flexWrap: 'wrap',
                    }}>
                    {actData.userTags ?
                        actData.userTags.split(', ').map((chipItem) => {
                            return (
                                <Chip
                                    key={chipItem}
                                    label={chipItem}
                                    sx={{ mr: '4px', mb: '2px' }}
                                />
                            );
                        })
                        : null}
                </Box>
                {eventInfo && eventInfo.moduleDetails && eventInfo.moduleDetails.length > 0 ? (() => {
                    const relevantModules = eventInfo.moduleDetails.filter(module =>
                        [22, 4, 7, 1, 26, 17, 8, 20, 25, 27, 28, 29].includes(module.moduleID)
                    );
                    const totalwidth = relevantModules.length * 6;
                    // console.log('totalwidth :',totalwidth);
                    // console.log('relevantModules.length :',relevantModules.length);
                    const dynamicWidth = `${totalwidth / relevantModules.length}%`;
                    //console.log('dynamicWidth :',dynamicWidth);

                    return relevantModules.map((module) => {

                        return (
                            <>
                                {(module.moduleID === AppConstants.EVENT_MODULES.DRAFT_HOTEL ||
                                    module.moduleID === AppConstants.EVENT_MODULES.COMBINE_HOTEL ||
                                    module.moduleID === AppConstants.EVENT_MODULES.ALL_STAR_HOTEL) &&
                                    <AllotmentRowItem
                                        dynamicWidth={dynamicWidth}
                                        displayName={module.displayName}
                                        showSubHeader
                                        subHeader={'C/P'}
                                        allotedValue={(actData?.allotments?.length > 0 && actData?.allotments !== undefined)
                                            ? actData.allotments[0].hotelSetting !== null
                                                ? JSON.parse(actData.allotments[0].hotelSetting).comp !== ""
                                                    ? JSON.parse(actData.allotments[0].hotelSetting).comp + '/' + JSON.parse(actData.allotments[0].hotelSetting).pay
                                                    : 0
                                                : 0
                                            : 0}
                                    />
                                }
                                {(module.moduleID === AppConstants.EVENT_MODULES.TRANSPORTATION ||
                                    module.moduleID === AppConstants.EVENT_MODULES.COMBINE_FLIGHTINFO) &&
                                    <AllotmentRowItem
                                        dynamicWidth={dynamicWidth}
                                        displayName={module.displayName}
                                        showSubHeader
                                        subHeader={'A/D'}
                                        allotedValue={(actData?.allotments?.length > 0 && actData?.allotments !== undefined)
                                            ? actData.allotments[0].transportSetting !== null
                                                ? JSON.parse(actData.allotments[0].transportSetting).arrival !== "" || JSON.parse(actData.allotments[0].transportSetting).arrival !== undefined
                                                    ? JSON.parse(actData.allotments[0].transportSetting).arrival + '/' + JSON.parse(actData.allotments[0].transportSetting).departure
                                                    : 0
                                                : 0
                                            : 0}
                                    />
                                }
                                {(module.moduleID === AppConstants.EVENT_MODULES.ALL_STAR_HOTEL) && (
                                    <>
                                        <AllotmentRowItem
                                            dynamicWidth={dynamicWidth}
                                            displayName={'Comp'}
                                            showSubHeader
                                            subHeader={'Fr/Sa/Su'}
                                            allotedValue={(actData?.allotments?.length > 0 && actData?.allotments !== undefined)
                                                ? actData.allotments[0].ticketSetting !== null
                                                    ? JSON.parse(actData.allotments[0].ticketSetting).ticketFriCompCount !== ""
                                                        ? JSON.parse(actData.allotments[0].ticketSetting).ticketFriCompCount + '/' + JSON.parse(actData.allotments[0].ticketSetting).ticketSatCompCount + '/' + JSON.parse(actData.allotments[0].ticketSetting).ticketSunCompCount
                                                        : 0
                                                    : 0
                                                : 0}
                                        />

                                        <AllotmentRowItem
                                            dynamicWidth={dynamicWidth}
                                            displayName={'Purchase'}
                                            showSubHeader
                                            subHeader={'Fr/Sa/Su'}
                                            allotedValue={(actData?.allotments?.length > 0 && actData?.allotments !== undefined)
                                                ? actData.allotments[0].ticketSetting !== null
                                                    ? JSON.parse(actData.allotments[0].ticketSetting).ticketFriPurCount !== ""
                                                        ? JSON.parse(actData.allotments[0].ticketSetting).ticketFriPurCount + '/' + JSON.parse(actData.allotments[0].ticketSetting).ticketSatPurCount + '/' + JSON.parse(actData.allotments[0].ticketSetting).ticketSunPurCount
                                                        : 0
                                                    : 0
                                                : 0}
                                        />
                                        <AllotmentRowItem
                                            dynamicWidth={dynamicWidth}
                                            displayName={'Add Purchase'}
                                            showSubHeader
                                            subHeader={'Fr/Sa/Su'}
                                            allotedValue={(actData?.allotments?.length > 0 && actData?.allotments !== undefined)
                                                ? actData.allotments[0].ticketSetting !== null
                                                    ? JSON.parse(actData.allotments[0].ticketSetting).ticketFriAddPurCount !== ""
                                                        ? JSON.parse(actData.allotments[0].ticketSetting).ticketFriAddPurCount + '/' + JSON.parse(actData.allotments[0].ticketSetting).ticketSatAddPurCount + '/' + JSON.parse(actData.allotments[0].ticketSetting).ticketSunAddPurCount
                                                        : 0
                                                    : 0
                                                : 0}
                                        />

                                    </>
                                )}
                                {(module.moduleID === AppConstants.EVENT_MODULES.DRAFT_TICKET) &&
                                    <AllotmentRowItem
                                        dynamicWidth={dynamicWidth}
                                        displayName={module.displayName}
                                        allotedValue={(item.actualData?.allotments?.length > 0 && item.actualData?.allotments !== undefined)
                                            ? item.actualData.allotments[0].draftTicketSetting !== null
                                                ? JSON.parse(item.actualData.allotments[0].draftTicketSetting).draftTicketCount !== "" || JSON.parse(item.actualData.allotments[0].draftTicketSetting).draftTicketCount !== undefined
                                                    ? JSON.parse(item.actualData.allotments[0].draftTicketSetting).draftTicketCount
                                                    : 0
                                                : 0
                                            : 0}
                                    />
                                }
                                {(module.moduleID === AppConstants.EVENT_MODULES.DRAFT_TRANSPORTATION) &&
                                    // <AllotmentRowItem
                                    //     dynamicWidth={dynamicWidth}
                                    //     displayName={module.displayName}
                                    //     showSubHeader
                                    //     subHeader={'B/E'}
                                    //     allotedValue={(item.actualData?.allotments?.length > 0 && item.actualData?.allotments !== undefined)
                                    //         ? item.actualData.allotments[0].draftTransportSetting !== null
                                    //             ? JSON.parse(item.actualData.allotments[0].draftTransportSetting).business !== "" || JSON.parse(item.actualData.allotments[0].draftTransportSetting).business !== undefined
                                    //                 ? JSON.parse(item.actualData.allotments[0].draftTransportSetting).business + '/' + JSON.parse(item.actualData.allotments[0].draftTransportSetting).economy
                                    //                 : 0
                                    //             : 0
                                    //         : 0}
                                    // />
                                    <AllotmentRowItem
                                        dynamicWidth={dynamicWidth}
                                        displayName={module.displayName}
                                        allotedValue={(item.actualData?.allotments?.length > 0 && item.actualData?.allotments !== undefined)
                                            ? item.actualData.allotments[0].draftTransportSetting !== null
                                                ? JSON.parse(item.actualData.allotments[0].draftTransportSetting).draftTransportCount !== "" || JSON.parse(item.actualData.allotments[0].draftTransportSetting).draftTransportCount !== undefined
                                                    ? JSON.parse(item.actualData.allotments[0].draftTransportSetting).draftTransportCount
                                                    : 0
                                                : 0
                                            : 0}
                                    />
                                }
                                {(module.moduleID === AppConstants.EVENT_MODULES.CREDENTIAL) &&
                                    <AllotmentCredentialRowItem
                                        dynamicWidth={dynamicWidth}
                                        displayName={module.displayName}
                                        allotedValue={(item.actualData?.allotments?.length > 0 && item.actualData?.allotments !== undefined)
                                            ? item.actualData.allotments[0].credentialSetting !== null
                                                ? JSON.parse(item.actualData.allotments[0].credentialSetting).credential !== "" || JSON.parse(item.actualData.allotments[0].credentialSetting).credential !== undefined
                                                    ? JSON.parse(item.actualData.allotments[0].credentialSetting).credential
                                                    : 0
                                                : 0
                                            : 0}
                                    />
                                }
                                {(module.moduleID === AppConstants.EVENT_MODULES.DRAFT_FLIGHT_INFO) &&
                                    <AllotmentRowItem
                                        dynamicWidth={dynamicWidth}
                                        displayName={module.displayName}
                                        allotedValue={(item.actualData?.allotments?.length > 0 && item.actualData?.allotments !== undefined)
                                            ? item.actualData.allotments[0].draftFlightSetting !== null
                                                ? JSON.parse(item.actualData.allotments[0].draftFlightSetting).draftFlight !== "" ||
                                                    JSON.parse(item.actualData.allotments[0].draftFlightSetting).draftFlight !== undefined
                                                    ? JSON.parse(item.actualData.allotments[0].draftFlightSetting).draftFlight
                                                    : 0
                                                : 0
                                            : 0}
                                    />
                                }
                                {(module.moduleID === AppConstants.EVENT_MODULES.LUNCHROOM) &&
                                    <AllotmentRowItem
                                        dynamicWidth={dynamicWidth}
                                        displayName={module.displayName}
                                        allotedValue={(item.actualData?.allotments?.length > 0 && item.actualData?.allotments !== undefined)
                                            ? item.actualData.allotments[0].lunchRoomSetting !== null
                                                ? JSON.parse(item.actualData.allotments[0].lunchRoomSetting).lunchRoom !== "" || JSON.parse(item.actualData.allotments[0].lunchRoomSetting).lunchRoom !== undefined
                                                    ? JSON.parse(item.actualData.allotments[0].lunchRoomSetting).lunchRoom
                                                    : 0
                                                : 0
                                            : 0}
                                    />
                                }
                                {(module.moduleID === AppConstants.EVENT_MODULES.GREENROOM) &&
                                    <AllotmentRowItem
                                        dynamicWidth={dynamicWidth}
                                        displayName={module.displayName}
                                        allotedValue={(item.actualData?.allotments?.length > 0 && item.actualData?.allotments !== undefined)
                                            ? item.actualData.allotments[0].greenRoomSetting !== null
                                                ? JSON.parse(item.actualData.allotments[0].greenRoomSetting).greenRoom !== "" || JSON.parse(item.actualData.allotments[0].greenRoomSetting).greenRoom !== undefined
                                                    ? JSON.parse(item.actualData.allotments[0].greenRoomSetting).greenRoom
                                                    : 0
                                                : 0
                                            : 0}
                                    />
                                }
                            </>
                        );
                    });
                })() : null}

                {/* <Box
                    sx={{
                        display: 'flex',
                        justifyContent: 'left',
                        flexDirection: 'column',
                        alignItems: 'start',
                        width: '5%',
                        flexBasis: '5%',
                        flexGrow: 1,
                    }}>
                    <Typography
                        variant="h4"
                        flexGrow={1}
                        fontSize={12}
                        fontWeight={500}
                        color="primary">
                        Status
                    </Typography>
                    <Typography
                        variant="h4"
                        flexGrow={1}
                        fontSize={14}
                        fontWeight={400}>
                        <span>{actData.status ? 'Active' : 'Inactive'}</span>
                    </Typography>
                </Box> */}
                <Box
                    sx={{
                        display: 'flex',
                        justifyContent: 'flex-end',
                        width: '5%',
                        flexBasis: '5%',
                        flexGrow: 1,
                    }}>
                    {props.modPermission &&
                        props.modPermission == FULL_PERMISSION ? (
                        <Tooltip title="Edit" aria-label="edit">
                            <IconButton
                                color="primary"
                                onClick={() => props.editRow(item)}>
                                <EditOutlinedIcon
                                    fontSize="small"
                                    color={'primary'}
                                />
                            </IconButton>
                        </Tooltip>
                    ) : null}
                </Box>
            </Box>
        </>
    )
}
export default AllotmentRow;